import React from 'react';
import { SetPasswordIcon } from 'common/Icons';
import { Form } from './Components/Form';
import { useTranslation } from 'react-i18next';

export const MobileSetPassword = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-rows-none">
      <div className="absolute left-0 -top-4">
        <SetPasswordIcon />
      </div>
      <div className="p-4 mt-[70px]">
        <div className="mt-4">
          <h1 className="text-5xl font-medium mb-2">
            {t(`FormSide.ResetPasswordText`)}
          </h1>
          <Form />
        </div>
      </div>
    </div>
  );
};
